"use client"

import { HeartMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HeartMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HeartMinusIcon = component(Icon)({ as: HeartMinus })
